import { Box, Skeleton } from '@mui/material';

import { ListColumn } from '../../../components/lists/ListColumn';
import { ListItem } from '../../../components/lists/ListItem';
import { ListButtonsColumn } from './ListButtonsColumn';
import { ReactNode } from 'react';

export interface IListItemLoaderProps {
  head: ReactNode[];
  buttonsColumnSize?: 'small' | 'medium' | 'big' | 'large';
  firstColumnWidth?: number;
  secondButton?: boolean;
}

export const ListItemLoader = ({ head, buttonsColumnSize, firstColumnWidth, secondButton }: IListItemLoaderProps) => {
  const countColumns = head.length - 1;
  return (
    <ListItem>
      <ListColumn
        maxWidth={firstColumnWidth || 160}
        minWidth={firstColumnWidth || 160}
        isRow
      >
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="circular" width={32} height={32} sx={{ marginLeft: -1.6 }} />
          <Skeleton sx={{ ml: 3 }} width={160} height={20} />
        </Box>
      </ListColumn>

      {Array.from({ length: countColumns }).map(() => (
        <ListColumn>
          <Skeleton width={70} height={20} />
        </ListColumn>
      ))}

      <ListButtonsColumn size={buttonsColumnSize}>
        <Skeleton height={36} width={68} sx={{ ml: '6px' }} />
        {secondButton && <Skeleton height={36} width={100} sx={{ ml: '6px' }} />}
      </ListButtonsColumn>
    </ListItem>
  );
};
